import { type OrganicStatsResponseDimensionEntry, type UserDimension } from "../../gql-generated/types";

export const ejectReportDimensionStatsList =
    (reportDimension: UserDimension) =>
    (statsList: readonly OrganicStatsResponseDimensionEntry[]): OrganicStatsResponseDimensionEntry[] =>
        statsList.filter(({ field }) => field?.reportDimension === reportDimension);
